export const LDMSRequestType = [
  { id: "ASSIGNMENT", name: "Assignment" },
  { id: "PREMIUM_FINANCE", name: "Premium Finance" },
  { id: "LOAN", name: "Loan Against Policy" },
];

export const AllowedProfileEditStatus = ["PENDING", "REJECTED", "NOT_UPDATED"];
export const maxFileSize = 5000000;

export const ROLES = ['POLICY_MASTER', 'PARTNER', "INVESTOR"];

export const ADMIN_ROLES = ['ADMIN', 'SUPERVISOR', 'DE', 'MANAGER']

